import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { EventPricingMatrix, EventType } from '../../../../../../../models/event-type';

import { AccountService } from '../../../../../../../services/account/account.service';
import { EventTypeService } from '../../../../../../../services/event-type/event-type.service';
import { ScheduleType } from '../../../../../../../models/event-type-enums';
import { CapitanLocation } from '../../../../../../../models/location';
import { LocationService } from '../../../../../../../services/location/location.service';
import { getAllowedLocationsForEventType } from '../../../../../../../utils-models';

@Component({
  selector: 'app-event-type-edit-schedule',
  templateUrl: './event-type-edit-schedule.component.html',
  styleUrls: ['./event-type-edit-schedule.component.css']
})
export class EventTypeEditScheduleComponent implements OnInit {
  public eventType: EventType = null;
  public pricingMatrices: EventPricingMatrix[] = null;

  public loadingEventType = false;
  public loadingPricingMatrices = false;

  public eventTypeNotFound = false;
  public serverError: number = null;

  public readonly ScheduleType = ScheduleType;

  private locations: CapitanLocation[] = null;

  constructor(
    private route: ActivatedRoute,
    private accountService: AccountService,
    private eventTypeService: EventTypeService,
    private locationService: LocationService,
  ) {}

  ngOnInit() {
    const routeParams = this.route.snapshot.params;
    const eventTypeIdInt = parseInt(routeParams.eventTypeId, 10);
    if (isNaN(eventTypeIdInt)) {
      this.eventTypeNotFound = true;
      return;
    }

    this.loadEventType(eventTypeIdInt);
    this.loadPricingMatrices(eventTypeIdInt);
    this.loadLocations();
  }

  public getAllowedLocations() {
    return getAllowedLocationsForEventType(this.eventType, this.locations);
  }

  /**
   * Load the event type with the given ID.
   *
   * @param eventTypeId - The API ID of the event type.
   */
  private loadEventType(eventTypeId: number) {
    this.loadingEventType = true;

    this.eventTypeService
      .getEventType(eventTypeId)
      .then(eventType => {
        this.eventType = eventType;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else if (reason.status === 404) {
          this.eventTypeNotFound = true;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingEventType = false; });
  }

  private loadPricingMatrices(eventTypeId: number) {
    this.loadingPricingMatrices = true;

    this.eventTypeService
      .getEventPricingMatrices(eventTypeId, 1, 100)
      .then(pricingMatricesResponse => {
        this.pricingMatrices = pricingMatricesResponse.results;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else if (reason.status === 404) {
          this.eventTypeNotFound = true;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingPricingMatrices = false; });
  }

  private loadLocations() {
    this.locations = this.locationService.getLocations();
    if (this.locations === null) {
      this.locationService
        .loadLocations()
        .then(() => {
          this.locations = this.locationService.getLocations();
        });
    }
  }
}
